export default "__VITE_ASSET__CWolDNmF__"